import * as React from 'react';
import { Persona as FabricPersona } from '@fluentui/react/lib/components/Persona/Persona';
import { PersonaSize } from './Persona.types';
import { useGraphPhoto } from '../../Hooks/useGraphPhoto';
export const Persona = (props) => {
    const { emailAlias } = props;
    const photo = useGraphPhoto(emailAlias, getPixelSize(props.size));
    if (!photo)
        return React.createElement(FabricPersona, Object.assign({}, props));
    return React.createElement(FabricPersona, Object.assign({}, props, { imageUrl: photo }));
};
const getPixelSize = (size) => {
    switch (size) {
        case PersonaSize.size8:
        case PersonaSize.size24:
        case PersonaSize.size32:
        case PersonaSize.size40:
        case PersonaSize.size48:
            return 48;
        case PersonaSize.size56:
            return 64;
        case PersonaSize.size72:
            return 96;
        case PersonaSize.size100:
        case PersonaSize.size120:
            return 120;
        default:
            return undefined;
    }
};
//# sourceMappingURL=Persona.js.map